import { Link as GatsbyLink, GatsbyLinkProps } from "gatsby";
import React from "react";
import { withUTM } from "../../utils/navigation";

/**
 * Feb 16th 2020 - ported over from https://github.com/perpetua1/perpetua-blog/blob/f0794e000cb13cbbf121e43f2ba6710e6ff408b6/src/components/Link/index.js
 * and converted to typescript
 *
 * Taken from https://www.gatsbyjs.org/docs/gatsby-link/#reminder-use-link-only-for-internal-links
 *
 * To be used for redirecting to different pages
 * This will determine whether to use a Gatsby <Link> component or the default <a> based on where we're navigating to
 * Use <Link> when navigating to internal (internal to gatsby) pages
 * <a> otherwise
 *
 * @param to If internal of the form: "/blog"
 * @param to If external of the form: "https://www.fijiwater.com/"
 * href is usable as well - but to is checked first
 */


interface LinkProps extends Omit<GatsbyLinkProps<{}>, "ref"> {
  href?: string;
}

const Link: React.FC<LinkProps> = props => {
  const {
    children,
    to,
    id,
    className,
    href,
    rel,
    onClick,
    onMouseEnter,
    onMouseOut,
    onMouseDown,
    onMouseUp,
    ...other
  } = props;
  
  const navURL = to ? to : href ? href : '';
  const internal = /^(\/|https:\/\/perpetua\.io)/.test(navURL); // isInternalToGatsby(navURL);
  const URLWithParams = withUTM(navURL);

  let defaults = {
    id: id,
    className: className,
    onClick: onClick,
    onMouseUp: onMouseUp,
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    onMouseOut: onMouseOut,
    ...other
  };

  defaults = rel !== undefined && rel !== '' 
  ? internal
      ? {...defaults, ...{rel: rel}}
      : {...defaults, ...{rel: `noreferrer ${rel}`.trim()}} 
  : defaults;

  const target = navURL === 'javascript:void(0)' ? '_self' : '_blank'; // not built by Gatsby = custom external

  return internal
    ? <GatsbyLink to={URLWithParams} {...defaults}>{children}</GatsbyLink>
    : <a href={URLWithParams} target={target} {...defaults}>{children}</a>
};

export default Link;
